import { render, staticRenderFns } from "./SingleBookSummary.vue?vue&type=template&id=07f85c40"
import script from "./SingleBookSummary.vue?vue&type=script&lang=js"
export * from "./SingleBookSummary.vue?vue&type=script&lang=js"
import style0 from "./SingleBookSummary.vue?vue&type=style&index=0&id=07f85c40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports